import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// components
import Iconify from '../../components/Iconify';
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import HelpPopover from '../../components/HelpPopover';
import { Badge, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getConversationUnread } from 'src/service/conversationApi';
import AuthContext from 'src/contexts/AuthContext';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const navigate = useNavigate();
  const { customerId } = useContext(AuthContext);
  const [unreadCount, setUnreadCount] = useState(0);
  const [hasNewNotifications, setHasNewNotifications] = useState(false);

  useEffect(() => {
    let isMounted = true;
    let previousCount = 0;
    
    const fetchUnreadMessages = async () => {
      
      if (customerId && isMounted) {
        try {
          
          const unreadMessages = await getConversationUnread(customerId);
          
          if (isMounted) {
            const currentCount = unreadMessages.length;
            
            
            // Détecter les nouvelles notifications
            if (currentCount > previousCount && previousCount > 0) {
              
              setHasNewNotifications(true);
              // L'animation reste active jusqu'au clic sur la cloche
            }
            
            // Si on a des notifications et qu'on n'a pas encore cliqué, garder l'animation
            if (currentCount > 0 && !hasNewNotifications) {
              
              setHasNewNotifications(true);
            }
            
            
            // Si on n'a plus de notifications, réinitialiser l'animation
            if (currentCount === 0) {
              
              setHasNewNotifications(false);
            }
            
            setUnreadCount(currentCount);
            previousCount = currentCount;
            
            
          }
        } catch (error) {
          console.error('❌ Erreur lors de la récupération des messages non lus:', error);
        }
      } else {
        
      }
    };

    // Écouter les événements de mise à jour de messages
    const handleMessageRead = (event) => {
      
      // Forcer la mise à jour immédiate
      fetchUnreadMessages();
    };

    fetchUnreadMessages();
    const interval = setInterval(() => {
      
      fetchUnreadMessages();
    }, 60000); // Vérifie toutes les 60 secondes
    
    
    // Ajouter l'écouteur d'événement
    window.addEventListener('messageRead', handleMessageRead);
    
    return () => {
      isMounted = false;
      clearInterval(interval);
      window.removeEventListener('messageRead', handleMessageRead);
    };
  }, [customerId]);

  const handleMessagesClick = () => {
    // Réinitialiser l'animation de nouvelles notifications quand on clique
    setHasNewNotifications(false);
    navigate('/dashboard/messages');
  };



  return (
    <div className="fixed top-0 right-0 z-50 w-full lg:w-[calc(100%-281px)] bg-white lg:bg-white/72 shadow-sm">
      <div className="flex items-center justify-between h-16 lg:h-[92px] px-4 lg:px-5">
        <div className="flex items-center">
          <button
            onClick={onOpenSidebar}
            className="lg:hidden p-2 text-gray-700 hover:bg-gray-100 rounded-md"
          >
            <Iconify icon="eva:menu-2-fill" />
          </button>
        </div>

        {/* <Searchbar /> */}
        <div className="flex-grow" />
        
        <div className="flex items-center space-x-1 sm:space-x-2">
          <HelpPopover />
          <div className="flex flex-col items-center mr-2 relative">
            <IconButton onClick={handleMessagesClick}>
              <Badge badgeContent={unreadCount} color="error">
                <Iconify 
                  icon="eva:bell-fill" 
                  width={20} 
                  height={20}
                  sx={{ 
                    width: { xs: 20, sm: 24 }, 
                    height: { xs: 20, sm: 24 } 
                  }}
                  className={`${unreadCount > 0 ? 'animate-pulse' : ''} ${hasNewNotifications ? 'text-red-500' : unreadCount > 0 ? 'text-red-600' : 'text-gray-600'}`}
                />
              </Badge>
            </IconButton>
            {unreadCount > 0 && (
              <span className="text-xs mt-1 text-red-600 font-semibold">
                {`${unreadCount} notification${unreadCount > 1 ? 's' : ''}`}
              </span>
            )}
            {/* Indicateur visuel pour nouvelles notifications */}
            {hasNewNotifications && (
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-ping"></div>
            )}
            {/* Indicateur statique pour notifications persistantes */}
            {unreadCount > 0 && !hasNewNotifications && (
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></div>
            )}
          </div>
          <AccountPopover />
        </div>
      </div>
    </div>
  );
}
